import React from 'react'

import { IconDone, IconError } from '../Icon'
import SimpleTable from '../SimpleTable'

interface Field {
  value: string | undefined
  label: string
}

interface Props {
  fields: Field[]
}

interface FoundAndMissing {
  found: Field[]
  missing: Field[]
}

const fieldHasContent = (field: Field): boolean =>
  !!field && !!field.value && field.value !== ''

/**
 * Separate out found and missing data from the fields array
 */
const toFoundAndMissing = (foundAndMissing: FoundAndMissing, field: Field) => {
  const { found, missing } = foundAndMissing

  if (fieldHasContent(field)) {
    found.push(field)
  } else {
    missing.push({ label: field.label, value: 'Edit on next step' })
  }

  return foundAndMissing
}

const Content: React.FunctionComponent<Props> = ({ fields }) => {
  const { missing, found } = fields.reduce(toFoundAndMissing, { found: [], missing: [] })
  const cssClass = missing.length > 0 ? 'eval-2columns' : 'eval-1column'
  const foundHeader = "Here's what we found:"
  const missingHeader = "Here's what we'll need your help with:"
  return (
    <div className="eval-results">
      <div className={cssClass}>
        <div className="summary">
          {found.length > 0 && (
            <SimpleTable
              className="found datalist"
              header={foundHeader}
              items={found}
              icon={IconDone}
              idLabel="done"
            />
          )}
        </div>
      </div>
      <div className={cssClass}>
        <div className="summary">
          {missing.length > 0 && (
            <SimpleTable
              className="missing datalist"
              header={missingHeader}
              items={missing}
              icon={IconError}
              idLabel="error"
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default Content
